import { IdTypeService } from '@/modules/global-settings/miscellaneous/services/id-types.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';
// Create a new instance of the IdTypeService class
const idTypeService = new IdTypeService();
// ID Types module state
export const state = {
  idTypes: []
};
// ID Types module mutations
export const mutations = {
  ...make.mutations(state)
};
// ID Types module actions
export const actions = {
  /**
   * Fetches all ID Types
   * @param {Object} context - Vuex action context
   * @returns {Array} Array of ID Types
   *
   * @private This sets the ID Types in the state
   */
  async fetchIdTypes({ commit }) {
    try {
      const { data, status } = await idTypeService.fetchIdTypes();
      commit('SET_ID_TYPES', data);
      return status;
    } catch (error) {
      Logger.error('fetching id types');
      throw error;
    }
  },

  /**
   * Updates an ID Type
   * @param {Object} context - Vuex action context
   * @param {Object} payload - Vuex action payload
   * @param {String} payload.id - ID Type ID
   * @param {Object} payload.updates - ID Type updates
   * @returns {Number} HTTP status code
   *
   * @private This updates the ID Types in the state
   */
  async updateIdType({ dispatch }, { id, updates }) {
    try {
      const { status } = await idTypeService.updateIdType(id, updates);
      dispatch('fetchIdTypes');
      return status;
    } catch (error) {
      Logger.error('update id types');
      throw error;
    }
  },

  /**
   * Creates an ID Type
   * @param {Object} context - Vuex action context
   * @param {Object} idType - ID Type
   * @returns {Number} HTTP status code
   *
   * @private This will re-fetch the ID Types in the state
   */
  async createIdType({ dispatch }, idType) {
    try {
      const { status } = await idTypeService.createIdType(idType);
      dispatch('fetchIdTypes');
      return status;
    } catch (error) {
      Logger.error('update id types');
      throw error;
    }
  },

  /**
   * Deletes an ID Type
   * @param {Object} context - Vuex action context
   * @param {String} id - ID Type ID
   * @returns {Number} HTTP status code
   *
   * @private This will re-fetch the ID Types in the state
   */
  async deleteIdType({ dispatch }, id) {
    try {
      const { status } = await idTypeService.deleteIdType(id);
      dispatch('fetchIdTypes');
      return status;
    } catch (error) {
      Logger.error('update id types');
      throw error;
    }
  }
};

// ID Types module getters
export const getters = {
  ...make.getters(state),
  activeIdTypes(state) {
    return state.idTypes.filter((i) => i.status == true);
  }
};
